import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-left"><path fillRule="evenodd" clipRule="evenodd" d="M15.5304 3.46967C15.8233 3.76256 15.8233 4.23744 15.5304 4.53033L9.65168 10.409C8.773 11.2877 8.77301 12.7123 9.65169 13.591L15.5304 19.4697C15.8233 19.7626 15.8233 20.2374 15.5304 20.5303C15.2375 20.8232 14.7626 20.8232 14.4697 20.5303L8.59103 14.6517C7.12656 13.1872 7.12656 10.8128 8.59102 9.34837L14.4697 3.46967C14.7626 3.17678 15.2375 3.17678 15.5304 3.46967Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLeft;
